var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ContainerPainel from '../../../components/container_painel';
import { BotaoAuxiliar, BotaoEditar, BotaoSalvar } from '../../../components/botoes';
import { BoxBotoes, BoxPrincipal } from '../../../components/form_box';
import { STATUS_API } from '../../../api';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { FUNCIONALIDADES, PAGINAS, ROUTES } from '../../../routes';
import { MODOS } from '../../../utils';
import { alterarUnidadePrisional, cadastrarUnidadePrisional, getTiposUnidadesPrisionaisParaSelecao, getUnidadePrisional } from './unidades_prisionais.service';
var MENSAGEM_DUPLICADO = 'Já existe uma unidade prisional cadastrada com este nome.';
var MENSAGEM_TIPO_INDISPONIVEL = 'O tipo selecionado não está mais disponível. Selecione outro tipo.';
var MENSAGEM_ERRO_CADASTRO = 'No momento não foi possível realizar o cadastro da unidade prisional. Tente novamente mais tarde.';
var MENSAGEM_ERRO_EDICAO = 'No momento não foi possível salvar as alterações da unidade prisional. Tente novamente mais tarde.';
var MENSAGEM_FALHA_CARREGAMENTO = 'Não foi possível carregar os dados do registro. Tente novamente.';
var formatarDataHora = function (data) {
    return data
        ? new Date(data).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        })
        : '';
};
export var UnidadesPrisionaisAlterar = function () {
    var _a;
    var _b = useParams(), id = _b.id, modo = _b.modo;
    var idRegistro = id && id !== MODOS.CADASTRAR ? id : undefined;
    var modoFormulario = modo !== null && modo !== void 0 ? modo : (idRegistro ? MODOS.VISUALIZAR : MODOS.CADASTRAR);
    var estaEditando = modoFormulario === MODOS.ALTERAR;
    var estaVisualizando = modoFormulario === MODOS.VISUALIZAR;
    var _c = useState(''), nome = _c[0], setNome = _c[1];
    var _d = useState(''), tipoId = _d[0], setTipoId = _d[1];
    var _e = useState([]), tipos = _e[0], setTipos = _e[1];
    var _f = useState(null), registro = _f[0], setRegistro = _f[1];
    var _g = useState(''), erroNome = _g[0], setErroNome = _g[1];
    var _h = useState(''), erroTipo = _h[0], setErroTipo = _h[1];
    var _j = useState(null), modalAberto = _j[0], setModalAberto = _j[1];
    var _k = useState(null), tipoSucesso = _k[0], setTipoSucesso = _k[1];
    var _l = useState(false), salvando = _l[0], setSalvando = _l[1];
    var _m = useState(true), carregando = _m[0], setCarregando = _m[1];
    var _o = useState(false), falhaCarregamento = _o[0], setFalhaCarregamento = _o[1];
    var navigate = useNavigate();
    var location = useLocation();
    var _p = useAuth(), auth = _p.auth, getAcoesFuncionalidade = _p.getAcoesFuncionalidade;
    var acoes = getAcoesFuncionalidade(FUNCIONALIDADES.UNIDADES_PRISIONAIS);
    useEffect(function () {
        auth(null, FUNCIONALIDADES.UNIDADES_PRISIONAIS, modoFormulario);
    }, [auth, modoFormulario]);
    var redirecionarErroAcesso = function (httpStatus) {
        if (httpStatus === 401 || httpStatus === 403) {
            navigate(httpStatus === 401 ? ROUTES.LOGOUT : ROUTES.SEM_PERMISSAO);
            return true;
        }
        return false;
    };
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resposta_1, _a, respostaRegistro, respostaTipos, respostaErro, resposta, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setCarregando(true);
                    setFalhaCarregamento(false);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, 8, 9]);
                    if (estaEditando && !idRegistro) {
                        setFalhaCarregamento(true);
                        return [2 /*return*/];
                    }
                    if (!(estaVisualizando && idRegistro)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getUnidadePrisional(idRegistro)];
                case 2:
                    resposta_1 = _c.sent();
                    if ((resposta_1 === null || resposta_1 === void 0 ? void 0 : resposta_1.Status) === STATUS_API.ERRO) {
                        if (redirecionarErroAcesso(resposta_1.httpStatus))
                            return [2 /*return*/];
                        setFalhaCarregamento(true);
                        return [2 /*return*/];
                    }
                    if (!resposta_1 || typeof resposta_1.nome !== 'string') {
                        setFalhaCarregamento(true);
                        return [2 /*return*/];
                    }
                    setRegistro(resposta_1);
                    setNome(resposta_1.nome);
                    return [2 /*return*/];
                case 3:
                    if (!(estaEditando && idRegistro)) return [3 /*break*/, 5];
                    return [4 /*yield*/, Promise.all([
                            getUnidadePrisional(idRegistro, true),
                            getTiposUnidadesPrisionaisParaSelecao(true),
                        ])];
                case 4:
                    _a = _c.sent(), respostaRegistro = _a[0], respostaTipos = _a[1];
                    if ((respostaRegistro === null || respostaRegistro === void 0 ? void 0 : respostaRegistro.Status) === STATUS_API.ERRO || (respostaTipos === null || respostaTipos === void 0 ? void 0 : respostaTipos.Status) === STATUS_API.ERRO) {
                        respostaErro = (respostaRegistro === null || respostaRegistro === void 0 ? void 0 : respostaRegistro.Status) === STATUS_API.ERRO ? respostaRegistro : respostaTipos;
                        if (redirecionarErroAcesso(respostaErro.httpStatus))
                            return [2 /*return*/];
                        setFalhaCarregamento(true);
                        return [2 /*return*/];
                    }
                    if (!respostaRegistro || typeof respostaRegistro.nome !== 'string' || !Array.isArray(respostaTipos)) {
                        setFalhaCarregamento(true);
                        return [2 /*return*/];
                    }
                    setRegistro(respostaRegistro);
                    setNome(respostaRegistro.nome);
                    setTipoId(typeof respostaRegistro.tipo_id === 'number' ? respostaRegistro.tipo_id : '');
                    setTipos(respostaTipos);
                    return [2 /*return*/];
                case 5: return [4 /*yield*/, getTiposUnidadesPrisionaisParaSelecao()];
                case 6:
                    resposta = _c.sent();
                    if ((resposta === null || resposta === void 0 ? void 0 : resposta.Status) === STATUS_API.ERRO) {
                        if (redirecionarErroAcesso(resposta.httpStatus))
                            return [2 /*return*/];
                        setFalhaCarregamento(true);
                        return [2 /*return*/];
                    }
                    setTipos(Array.isArray(resposta) ? resposta : []);
                    return [3 /*break*/, 9];
                case 7:
                    _b = _c.sent();
                    setFalhaCarregamento(true);
                    return [3 /*break*/, 9];
                case 8:
                    setCarregando(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        void carregarDados();
        // Load the route's record or type options when its id or mode changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idRegistro, modoFormulario]);
    useEffect(function () {
        var _a, _b;
        if (((_a = location.state) === null || _a === void 0 ? void 0 : _a.cadastroConcluido) || ((_b = location.state) === null || _b === void 0 ? void 0 : _b.edicaoConcluida)) {
            setTipoSucesso(location.state.edicaoConcluida ? 'edicao' : 'cadastro');
            setModalAberto('sucesso');
            navigate(location.pathname, { replace: true, state: null });
        }
    }, [location.pathname, location.state, navigate]);
    var salvar = function () { return __awaiter(void 0, void 0, void 0, function () {
        var nomeNormalizado, dados, resposta, _a, idCriado, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (salvando)
                        return [2 /*return*/];
                    if (estaEditando ? !acoes.ALTERAR : !acoes.CADASTRAR) {
                        navigate(ROUTES.SEM_PERMISSAO);
                        return [2 /*return*/];
                    }
                    nomeNormalizado = nome.trim();
                    if (!nomeNormalizado) {
                        setErroNome('Campo obrigatório.');
                        return [2 /*return*/];
                    }
                    if (nomeNormalizado.length > 150) {
                        setErroNome('O nome deve possuir no máximo 150 caracteres.');
                        return [2 /*return*/];
                    }
                    setErroNome('');
                    setErroTipo('');
                    setSalvando(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 6, 7, 8]);
                    dados = { nome: nomeNormalizado, tipo_id: tipoId || null };
                    if (!(estaEditando && idRegistro)) return [3 /*break*/, 3];
                    return [4 /*yield*/, alterarUnidadePrisional(idRegistro, dados)];
                case 2:
                    _a = _d.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, cadastrarUnidadePrisional(dados)];
                case 4:
                    _a = _d.sent();
                    _d.label = 5;
                case 5:
                    resposta = _a;
                    if (resposta.Status === STATUS_API.OK) {
                        if (estaEditando && idRegistro) {
                            navigate("".concat(ROUTES.UNIDADES_PRISIONAIS, "/").concat(idRegistro, "/").concat(MODOS.VISUALIZAR), { state: { edicaoConcluida: true } });
                            return [2 /*return*/];
                        }
                        idCriado = (_c = resposta.dados) === null || _c === void 0 ? void 0 : _c.id;
                        if (idCriado) {
                            navigate("".concat(ROUTES.UNIDADES_PRISIONAIS, "/").concat(idCriado, "/").concat(MODOS.VISUALIZAR), { state: { cadastroConcluido: true } });
                        }
                        else {
                            setModalAberto('erro');
                        }
                        return [2 /*return*/];
                    }
                    if (redirecionarErroAcesso(resposta.httpStatus))
                        return [2 /*return*/];
                    if (resposta.Mensagem === MENSAGEM_DUPLICADO) {
                        setErroNome(MENSAGEM_DUPLICADO);
                        return [2 /*return*/];
                    }
                    if (resposta.Mensagem === MENSAGEM_TIPO_INDISPONIVEL) {
                        setTipoId('');
                        setErroTipo(MENSAGEM_TIPO_INDISPONIVEL);
                        return [2 /*return*/];
                    }
                    setModalAberto('erro');
                    return [3 /*break*/, 8];
                case 6:
                    _b = _d.sent();
                    setModalAberto('erro');
                    return [3 /*break*/, 8];
                case 7:
                    setSalvando(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var solicitarSaida = function () { return setModalAberto('cancelamento'); };
    var confirmarSaida = function () {
        if (estaEditando && idRegistro) {
            navigate("".concat(ROUTES.UNIDADES_PRISIONAIS, "/").concat(idRegistro, "/").concat(MODOS.VISUALIZAR));
            return;
        }
        navigate(ROUTES.UNIDADES_PRISIONAIS);
    };
    var fecharModalSucesso = function () {
        setModalAberto(null);
        setTipoSucesso(null);
    };
    var tituloPagina = estaVisualizando ? 'Visualizar' : estaEditando ? 'Alterar' : 'Cadastrar';
    if (carregando || falhaCarregamento) {
        return (_jsxs(ContainerPainel, __assign({ pagina_acima: PAGINAS.UNIDADES_PRISIONAIS, pagina_especifica_permissao: FUNCIONALIDADES.UNIDADES_PRISIONAIS, link_pagina_acima: ROUTES.UNIDADES_PRISIONAIS, modo: modoFormulario, titulo_pagina: tituloPagina, onNavegar: estaVisualizando ? undefined : solicitarSaida }, { children: [_jsx(BoxPrincipal, __assign({ sx: { minHeight: 180, alignItems: 'center', justifyContent: 'center' } }, { children: carregando ? (_jsx(CircularProgress, { size: 28 })) : (_jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 } }, { children: [_jsx(WarningAmberIcon, { color: 'warning', fontSize: 'large' }), _jsx(Box, { children: MENSAGEM_FALHA_CARREGAMENTO }), _jsx(Button, __assign({ variant: 'outlined', onClick: function () { return void carregarDados(); } }, { children: "Recarregar" }))] }))) })), !estaVisualizando && (_jsxs(Dialog, __assign({ open: modalAberto === 'cancelamento', onClose: function () { return setModalAberto(null); }, fullWidth: true, maxWidth: 'sm' }, { children: [_jsxs(DialogTitle, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [_jsx(WarningAmberIcon, { color: 'warning' }), " ", estaEditando ? 'Deseja cancelar a edição?' : 'Deseja cancelar o cadastro?'] })), _jsx(DialogContent, { children: estaEditando ? 'As alterações realizadas serão perdidas.' : 'Os dados preenchidos serão perdidos.' }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () { return setModalAberto(null); }, color: 'secondary' }, { children: "Voltar" })), _jsx(Button, __assign({ onClick: confirmarSaida, variant: 'contained', color: 'success' }, { children: "Confirmar" }))] })] })))] })));
    }
    return (_jsx(ContainerPainel, __assign({ pagina_acima: PAGINAS.UNIDADES_PRISIONAIS, pagina_especifica_permissao: FUNCIONALIDADES.UNIDADES_PRISIONAIS, link_pagina_acima: ROUTES.UNIDADES_PRISIONAIS, modo: modoFormulario, titulo_pagina: tituloPagina, onNavegar: estaVisualizando ? undefined : solicitarSaida }, { children: _jsxs(BoxPrincipal, { children: [_jsxs(Box, __assign({ sx: { display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'minmax(240px, 1fr) minmax(220px, 0.6fr)' }, gap: 1.5, width: '100%' } }, { children: [_jsx(TextField, { id: 'nome-unidade-prisional', label: 'Nome', value: nome, onChange: function (event) {
                                setNome(event.target.value);
                                if (erroNome)
                                    setErroNome('');
                            }, error: Boolean(erroNome), helperText: erroNome || ' ', required: true, fullWidth: true, inputProps: { maxLength: 150 }, disabled: salvando || estaVisualizando }), estaVisualizando ? (_jsx(TextField, { label: 'Tipo', value: (_a = registro === null || registro === void 0 ? void 0 : registro.tipo) !== null && _a !== void 0 ? _a : 'Não informado', disabled: true, fullWidth: true })) : (_jsxs(TextField, __assign({ id: 'tipo-unidade-prisional', label: 'Tipo', value: tipoId, onChange: function (event) {
                                setTipoId(event.target.value === '' ? '' : Number(event.target.value));
                                if (erroTipo)
                                    setErroTipo('');
                            }, error: Boolean(erroTipo), helperText: erroTipo || ' ', select: true, fullWidth: true, SelectProps: { displayEmpty: true, renderValue: function (value) {
                                    var _a, _b;
                                    if (value === '')
                                        return _jsx("em", { children: "Selecione" });
                                    return (_b = (_a = tipos.find(function (tipo) { return tipo.id === value; })) === null || _a === void 0 ? void 0 : _a.nome) !== null && _b !== void 0 ? _b : '';
                                } }, disabled: salvando }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: _jsx("em", { children: "Selecione" }) })), tipos.length ? tipos.map(function (tipo) { return _jsx(MenuItem, __assign({ value: tipo.id }, { children: tipo.nome }), tipo.id); }) : (_jsx(MenuItem, __assign({ disabled: true, value: 'sem-tipos' }, { children: _jsx("em", { children: "Nenhum tipo de unidade prisional cadastrado." }) })))] })))] })), estaVisualizando && registro && (_jsxs(Box, __assign({ sx: { mt: 1, display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 1.5, width: '100%' } }, { children: [_jsx(TextField, { label: 'Cadastrado por / em', value: [registro.usuario_nome, formatarDataHora(registro.created_at)].filter(Boolean).join(' — ') || '-', disabled: true, fullWidth: true }), _jsx(TextField, { label: '\u00DAltima altera\u00E7\u00E3o por / em', value: [registro.updated_by_nome, formatarDataHora(registro.updated_at)].filter(Boolean).join(' — ') || '-', disabled: true, fullWidth: true })] }))), _jsxs(BoxBotoes, { children: [estaVisualizando && idRegistro && _jsx(BotaoEditar, { onClick: function () { return navigate("".concat(ROUTES.UNIDADES_PRISIONAIS, "/").concat(idRegistro, "/").concat(MODOS.ALTERAR)); }, disabled: !acoes.ALTERAR }), !estaVisualizando && _jsx(BotaoSalvar, { onClick: function () { return void salvar(); }, disabled: salvando }), _jsx(BotaoAuxiliar, __assign({ backgroundColor: 'secondary.main', onClick: estaVisualizando ? function () { return navigate(ROUTES.UNIDADES_PRISIONAIS); } : solicitarSaida, disabled: salvando }, { children: estaVisualizando ? 'Fechar' : 'Voltar' }))] }), _jsxs(Dialog, __assign({ open: modalAberto === 'cancelamento', onClose: function () { return setModalAberto(null); }, fullWidth: true, maxWidth: 'sm' }, { children: [_jsxs(DialogTitle, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [_jsx(WarningAmberIcon, { color: 'warning' }), " ", estaEditando ? 'Deseja cancelar a edição?' : 'Deseja cancelar o cadastro?'] })), _jsx(DialogContent, { children: estaEditando ? 'As alterações realizadas serão perdidas.' : 'Os dados preenchidos serão perdidos.' }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () { return setModalAberto(null); }, color: 'secondary' }, { children: "Voltar" })), _jsx(Button, __assign({ onClick: confirmarSaida, variant: 'contained', color: 'success' }, { children: "Confirmar" }))] })] })), _jsxs(Dialog, __assign({ open: modalAberto === 'sucesso', onClose: fecharModalSucesso, fullWidth: true, maxWidth: 'sm' }, { children: [_jsxs(DialogTitle, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [_jsx(CheckCircleIcon, { color: 'success' }), " ", tipoSucesso === 'edicao' ? 'Edição realizada' : 'Cadastro realizado'] })), _jsx(DialogContent, { children: tipoSucesso === 'edicao' ? 'Alterações salvas com sucesso.' : 'Unidade prisional cadastrada com sucesso.' }), _jsx(DialogActions, { children: _jsx(Button, __assign({ onClick: fecharModalSucesso, variant: 'contained', color: 'success' }, { children: "OK" })) })] })), _jsxs(Dialog, __assign({ open: modalAberto === 'erro', onClose: function () { return setModalAberto(null); }, fullWidth: true, maxWidth: 'sm' }, { children: [_jsxs(DialogTitle, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [_jsx(ErrorIcon, { color: 'error' }), " ", estaEditando ? 'Não foi possível realizar a Edição' : 'Não foi possível realizar o Cadastro'] })), _jsx(DialogContent, { children: estaEditando ? MENSAGEM_ERRO_EDICAO : MENSAGEM_ERRO_CADASTRO }), _jsx(DialogActions, { children: _jsx(Button, __assign({ onClick: function () { return setModalAberto(null); }, variant: 'contained', color: 'warning' }, { children: "Voltar" })) })] }))] }) })));
};
export default UnidadesPrisionaisAlterar;
